









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class CFormGroup extends Vue {
    @Prop()
    label!: string;

    @Prop()
    name!: string;

    @Prop({
        default: 'default'
    })
    variant!: string;
}
